import React, { useEffect, useState } from 'react'
import { Grid } from '@mui/material'
import DataCard from '../../../components/shared/dataCard'
import { MenuBook, WorkspacePremium } from '@mui/icons-material'
import { ReactComponent as Book } from '../../../assets/book.svg'
import { ReactComponent as Posting } from '../../../assets/text-box-edit-outline.svg'
import { SumGroupStatus } from './SumGroupStatus'
import { object, bool } from 'prop-types'
import DashboardsPostagens from '../../../services/http/dashboards/DashboardsPostagens'

const ColaboradorDatacard = ({ filters = {} }) => {
  const [sumGroupStatus, setSumGroupStatus] = useState(new SumGroupStatus([]))

  const [loading, setLoading] = useState(true)

  useEffect(() => {
    if (Object.keys(filters).length > 1 && filters.leitor_id !== '') {
      init(filters)
    }
  }, [filters])

  async function init(filter = {}) {
    try {
      const { data } = await DashboardsPostagens().show({
        group_by: 'status_postagem_id,leitor_nome',
        count: 'postagem_id',
        ano_id: filter.ano_id || new Date().getFullYear(),
        leitor_id: filter.leitor_id
      })

      setSumGroupStatus(new SumGroupStatus(data.data))
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  }

  const data = [
    {
      legend: 'Livros',
      descricao:
        'Quantidade total de livros postados \n (aprovados, reprovados e aguardando análise)',
      value: sumGroupStatus.getTotal(),
      Icon: MenuBook,
      color: '#EA9027'
    },
    {
      legend: 'Aprovados',
      value: sumGroupStatus.getAprovadas(),
      descricao: 'Quantidade de livros aprovados',
      Icon: Posting,
      color: '#9D2AAF'
    },
    {
      legend: 'Reprovados',
      value: sumGroupStatus.getReprovadas(),
      descricao: 'Quantidade de livros reprovados',
      Icon: Book,
      color: '#D32F2F'
    },
    {
      legend: 'Conquistas',
      descricao: 'Conquistas alcançadas',
      value: 0,
      Icon: WorkspacePremium,
      color: '#185273'
    }
  ]

  return data.map((item, index) => {
    return (
      <Grid item xs={5.6} sm={2.8} key={index} sx={{ marginTop: '10px' }}>
        <DataCard
          Icon={item.Icon}
          legend={item.legend}
          value={item.value}
          color={item.color}
          descricao={item.descricao}
          loading={loading}
        />
      </Grid>
    )
  })
}

ColaboradorDatacard.propTypes = {
  filters: object,
  meta: bool
}

export default ColaboradorDatacard
